<template>
  <pt-trust-deed-list class="pt-trust-deed-list__page"></pt-trust-deed-list>
</template>

<script>
import PtTrustDeedList from 'cps/trust-deed/pt-trust-deed-list/withData'
export default {
  name: 'pt-trust-deed-list__view',
  components: {
    'pt-trust-deed-list': PtTrustDeedList
  }
}
</script>
